import { createApp } from 'vue';
import QuarterlyResultsBlock from './QuarterlyResultsBlock.vue';

// import "./CardGridBlock.scss";

const mountingQuarterlyResultsBlock = document.querySelector('[data-feature="quarterly-results-block"]');
if (mountingQuarterlyResultsBlock) {
	const app = createApp({
		name: 'QuarterlyResultsBlockApp',
	});
	app.component('quarterly-results-block', QuarterlyResultsBlock);
	app.mount(mountingQuarterlyResultsBlock);
}